import { StyledSpan } from '../shared/StyledSpan';

export const RetryMessage = (props: { msg: string }) => {
  return (
    <StyledSpan textAlign="center" justifyContent={'center'} marginTop={'15px'} marginBottom={'40px'} color="red">
      <div dangerouslySetInnerHTML={{ __html: props.msg }} />
    </StyledSpan>
  );
};
